import { WidgetsInfo } from '@/entities/widget.info';
import { PagesInfo } from '@/entities/page.info';

class SiteConfiguration {
  privateLabelId: number;
  languages: Array<Language>;
  configurations: Configurations;
}

class Configurations {
  endpoints?: any;
  widgets?: WidgetsInfo;
  pages?: PagesInfo;
}

class Language {
  languageCode: string;
  nativeLanguageName: string;
  defaultLanguage: boolean;
}

enum LOGOUT_TYPE {
    CLASSIC = 'classic',
    OKTA = 'okta',
}

const defaultAppLanguage: Language = new Language();
defaultAppLanguage.languageCode = 'en';
defaultAppLanguage.nativeLanguageName = 'English';
defaultAppLanguage.defaultLanguage = true;

export {
  SiteConfiguration,
  Language,
  defaultAppLanguage,
  LOGOUT_TYPE,
};
